module.exports = __webpack_public_path__ + "media/images/top/icon/black/ico_angle-7266ab76c2812e8955d36d6d2ab2a764.svg";